export default "__VITE_ASSET__BASpKyBI__"